import {decryptAES} from "@/helpers/decryptAES";
import {API} from "@/middlewares/api";
import {createAsyncThunk} from "@reduxjs/toolkit";

export const loadPartnerDetails = createAsyncThunk("partners/loadPartnerDetails", async (partnerId, thunkAPI) => {
  try {
    const response = await API(`partners/partner-details/${partnerId}`);

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const checkPartnerDetails = createAsyncThunk("partners/checkPartnerDetails", async (partnerId, thunkAPI) => {
  try {
    const response = await API(`partners/partner-details/${partnerId}`);

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const revokePartnerAccess = createAsyncThunk("/revokePartnerAccess", async (payload, thunkAPI) => {
  try {
    const response = await API("secure/partners/revoke-partner", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const approvePartnerAccess = createAsyncThunk("partners/approvePartnerAccess", async (payload, thunkAPI) => {
  try {
    const response = await API("secure/partners/approve-partner", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const revokeAwaitingPartnerAccess = createAsyncThunk(
  "partners/revokeAwaitingPartnerAccess",
  async (payload, thunkAPI) => {
    try {
      const response = await API("secure/partners/revoke-awaiting-partner", {method: "POST", body: payload});

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const updateTestPartnerAccess = createAsyncThunk(
  "partners/updateTestPartnerAccess",
  async (payload, thunkAPI) => {
    try {
      const response = await API("secure/partners/partner-access", {method: "POST", body: payload});

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const partnerAccessCode = createAsyncThunk("partners/partnerAccessCode", async (payload, thunkAPI) => {
  try {
    const response = await API("secure/partners/access-code", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const updatePartnerTest = createAsyncThunk("partners/updatePartnerTest", async (payload, thunkAPI) => {
  try {
    const queryParams = new URLSearchParams(window.location.search);

    const pt = queryParams.get("pt") || "";
    const partnerTokenEncrypted = decodeURIComponent(pt);
    const partnerToken = decryptAES(partnerTokenEncrypted);

    if (!partnerToken) {
      return Promise.reject(new Error("Invalid partner token"));
    }
    const customHeader = {Authorization: `Bearer ${partnerToken}`};
    const response = await API("secure/partners/update-test", {method: "POST", body: payload, headers: customHeader});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const loadParterAccount = createAsyncThunk("partners/loadParterAccount", async (partnerId, thunkAPI) => {
  try {
    const queryParams = new URLSearchParams(window.location.search);

    const pt = queryParams.get("pt") || "";
    const partnerTokenEncrypted = decodeURIComponent(pt);
    const partnerToken = decryptAES(partnerTokenEncrypted);

    let response;

    if (partnerId === "me") {
      if (!partnerToken) {
        return Promise.reject(new Error("Invalid partner token"));
      }

      const customHeader = {Authorization: `Bearer ${partnerToken}`};

      response = await API(`secure/partners/partner-details/${partnerId}`, {
        headers: customHeader,
        mustValidateToken: false,
      });
    } else {
      response = await API(`partners/partner-details/${partnerId}`, {mustValidateToken: false});
    }

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const getPartnerAccountFromRequestCode = createAsyncThunk(
  "partners/getPartnerAccountFromRequestCode",
  async (requestCode, thunkAPI) => {
    try {
      const response = await API("partners/get-partnerShop-details", {method: "POST", body: {requestCode}});

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const customiseBespokeTest = createAsyncThunk("partners/customiseBespokeTest", async (payload, thunkAPI) => {
  try {
    const response = await API("bespoke-test/rename-test", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const addPartnerTest = createAsyncThunk("partners/addPartnerTest", async (payload, thunkAPI) => {
  try {
    const response = await API("partners/add-partner-test", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const getBlankKitDetails = createAsyncThunk("partners/getBlankKitDetails", async ({blankKitId}, thunkAPI) => {
  try {
    const queryParams = new URLSearchParams(window.location.search);

    const pt = queryParams.get("pt") || "";
    const partnerTokenEncrypted = decodeURIComponent(pt);
    const partnerToken = decryptAES(partnerTokenEncrypted);

    if (!partnerToken) {
      return Promise.reject(new Error("Invalid partner token"));
    }

    const customHeader = {Authorization: `Bearer ${partnerToken}`};

    const response = await API(`secure/partner/blank-kit-details/${blankKitId}`, {headers: customHeader});

    return thunkAPI.fulfillWithValue(response);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const loadPartnerIdByHostname = createAsyncThunk(
  "partners/loadPartnerIdByHostname",
  async (payload, thunkAPI) => {
    try {
      const response = await API("partners/get-partner-id", {method: "POST", body: payload});

      return thunkAPI.fulfillWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);
